/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-06 14:25:28
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-06-08 12:44:24
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/Components/Options/index.tsx
 */
import { TableSelect } from '@/src/components';
import { SectionCollapse, SizeFittingTable } from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import classname from 'classnames';
import { get, uniq } from 'lodash';
import React from 'react';
import Option from './Option';
import styles from './style.module.less';

type Props = {
  products: Array<any>;
  options: Array<any>;
  disabled?: boolean;
  onAddOption?: () => void;
  onDeleteOption?: (index: number) => void;
  onChangeVariant?: (
    productIndex: number,
    variantIndex: number,
    value: string,
    onChangeVariant: string,
  ) => void;
  onChangeLabel?: (index: number, value: string) => void;
  onAddTag?: (index: number, value: string) => void;
  onDeleteTag?: (index: number, valueIndex: number) => void;
  onValidateValues?: (uuid: string) => void;
  onValidateLabel?: (uuid: string) => void;
  getI18n: (k: string) => string;
};

function Options({
  products,
  options: _o,
  disabled,
  onAddOption,
  onDeleteOption,
  onChangeLabel,
  onAddTag,
  onDeleteTag,
  onChangeVariant,
  onValidateLabel,
  getI18n,
}: Props) {
  const options = _o || [];
  const availableAllColsUuid = (options || [])
    .filter((o) => o.label && o.values.length !== 0)
    .map((o) => o.uuid);
  //

  // console.log('availableAllColsUuid', availableAllColsUuid);
  const optionLength = (options || []).filter(
    (option) => option.values?.length !== 0,
  ).length;

  const optionKeys = (options || [])
    .filter((option) => option.values?.length !== 0)
    .map((i) => i.uuid);

  const error = !products.every((p) =>
    p.variant
      .filter((v) => availableAllColsUuid.indexOf(v.id) !== -1)
      .every((v) => v.value),
  );
  //console.log('error', error);
  const columns = [
    {
      width: 56,
      default: true,
      title: '',
      key: 'index',
      childGenerate: (_, __, index: number) => index + 1,
    },
    {
      title: getI18n('general.storeCommunicationSetting.product'),
      // align: 'center',
      default: true,
      minWidth: 450,
      childGenerate: (_, record, index: number) => {
        return (
          <div className={styles.products}>
            {/* <div className={styles.index}>{index + 1}</div> */}
            <div
              className={styles.img}
              style={{ backgroundImage: `url('${record.thumbnailUrl}')` }}
            />
            <div className={styles.name}>{record.name}</div>
          </div>
        );
      },
    },
    ...(options || [])
      .filter((option) => option.values?.length !== 0)
      .map((option, vIndex) => {
        return {
          title:
            option.label ||
            `${getI18n('salesChannelProductDetail.index.label')} ${vIndex + 1}`,
          default: true,
          minWidth: 220,
          childGenerate: (_, record, index: number) => {
            return (
              <TableSelect
                allowClear
                key={record.uuid}
                onChange={
                  (e) => {
                    const optionsUuid = get(options[vIndex], 'uuid');
                    onChangeVariant(index, vIndex, e, optionsUuid);
                  }
                  // .bind(
                  // this,
                  // index,
                  // record.variant?.findIndex((v) => v.uuid === option.uuid),
                }
                value={
                  record?.variant?.find((v) => v.uuid === option.uuid)?.value
                }
                error={
                  record?.variant?.find((v) => v.uuid === option.uuid)?.err
                }
                help={record?.variant?.find((v) => v.uuid === option.uuid)?.err}
                options={option.values?.map((v) => ({ label: v, value: v }))}
                disabled={disabled}
              />
            );
          },
        };
      }),
  ];

  const renderContent = () => {
    const variantsArr = products
      .map((i) => get(i, 'variant') || [])
      .filter((i) => {
        const _i = i.filter((o) => o.value);
        return _i.length === optionLength;
      })
      .map((i) => {
        const obj = i.reduce((pre, now) => {
          const { value, uuid } = now;
          return { ...pre, [uuid]: value };
        }, {});
        return obj;
      });

    const valueInArr = variantsArr.map((i) => {
      const vR = optionKeys.map((k) => i[k]).join(',');
      return vR;
    });

    const uniqArr = uniq(valueInArr);
    // const variantsObject = (variantsArr || []).reduce((pre, now) => {
    //   (now || []).forEach((i) => {
    //     const uuid = get(i, 'uuid');
    //     const value = get(i, 'value');
    //     if (pre[uuid]) {
    //       if (value) {
    //         pre[uuid] = [...(pre[uuid] || []), value];
    //       }
    //     } else {
    //       if (value) {
    //         pre[uuid] = [value];
    //       } else {
    //         pre[uuid] = [];
    //       }
    //     }
    //   });
    //   return pre;
    // }, {});
    // console.log('variantsObject', variantsObject);
    const hasDuplicate = uniqArr.length !== valueInArr.length;
    // Object.keys(variantsObject).reduce((pre, now) => {
    //   if (!pre) {
    //     const arr = variantsObject[now] || [];
    //     const intactLength = arr.length;
    //     const uniqArr = uniq(arr);
    //     const uniqArrLength = uniqArr.length;
    //     return intactLength !== uniqArrLength;
    //   }
    //   return pre;
    // }, false);

    return (
      <div className={styles.content}>
        {options.map((option, index) => {
          const {
            label,
            values,
            uuid,
            labelError,
            valuesError,
            labelHelp,
            valuesHelp,
          } = option;
          return (
            <Option
              index={index}
              labelError={labelError}
              labelHelp={labelHelp}
              valuesError={valuesError}
              valuesHelp={valuesHelp}
              key={uuid}
              value={label}
              options={options}
              tags={values}
              disabled={disabled}
              setLabel={onChangeLabel}
              onPress={onAddTag}
              deleteValue={onDeleteTag}
              removeOption={onDeleteOption}
              onValidateLabel={onValidateLabel.bind(this, index)}
            />
          );
        })}
        {options.length < 3 && !disabled && (
          <div className={styles.add}>
            <span className={styles.plus} onClick={onAddOption}>
              <Icon type='iconplus' className={styles.icon} />
              {getI18n('salesChannelProductDetail.index.addanOption')}
            </span>
          </div>
        )}
        <div className={styles.comb}>
          {error && (
            <div className={styles.error}>
              <Icon type='iconinfo1' className={styles.icon} />
              {getI18n(
                'salesChannelProductDetail.index.assignoptionvalueproduct',
              )}
            </div>
          )}

          {options.filter((o) => o.values?.length !== 0).length !== 0 && (
            <>
              <div className={styles.combTitle}>
                {getI18n(
                  'salesChannelProductDetail.index.selectoptionvalueforeachproduct',
                )}
              </div>
              <SizeFittingTable
                rowKey={'uuid'}
                id={'salesChannelOptionsProductsTable'}
                rowClassName={styles.row}
                className={styles.table}
                pagination={false}
                columns={columns}
                dataSource={products}
              />
              {hasDuplicate && (
                <div className={styles.errorTip}>
                  {getI18n('salesChannelProductDetail.index.hasDuplicateError')}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  const renderTitle = () => {
    return (
      <div className={styles.title}>
        <div className={'collapseTitle'}>
          {getI18n('salesChannelProductDetail.index.productsLabel')}
        </div>
        <div className={styles.subTitle}>
          {getI18n('salesChannelProductDetail.index.productsLabelsubTitle')}
        </div>
      </div>
    );
  };

  return (
    <div className={classname(styles.container)}>
      <SectionCollapse
        open={true}
        id={'salesChannelLinkProductPrice'}
        titleStyle={{ height: '64px' }}
        title={renderTitle()}
        content={renderContent()}
        openMargin={16}
      />
    </div>
  );
}

export default Options;
